import React from 'react';
import { useTranslation } from 'react-i18next';
import Vale from '../Vales';

const ValesNoActivados = ({
  valesNoAct,
  setVisible,
  setPromocion,
  isMobile,
  retrieveValesAhorro,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <div className="listado-vales">
        <h2 className="bloque-datos__title u-text-brand">
          <span className="divider__square brand-color" />
          <span className="u-margin-right">{t('vales.noActivos')}</span>
        </h2>
        <div className="listado-vales__filtro" />
      </div>

      <div className="listado-vales listado-vales__activos">
        {valesNoAct &&
          valesNoAct.map((valeData, index) => (
            <Vale
              setPromocion={setPromocion}
              preActivado={false}
              key={`vale-${valeData.valeEAN}`}
              data={valeData}
              cargarVales={retrieveValesAhorro}
              valeIndex={isMobile ? 0 : index}
              showCondLegales={setVisible}
            />
          ))}
      </div>
    </>
  );
};

export default ValesNoActivados;
